export enum TipoSexo {
  'Masculino' = 1,
  'Feminino' = 2,
  'Outro' = 3,
  'Prefiro não informar' = 4,
}